module.exports = __webpack_public_path__ + "img/TRIESTE.b5988fac.png";